import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ProductDoc } from './product-roadmap-constants';

interface ReferenceDocPanelProps {
  docs: ProductDoc[];
}

export const ReferenceDocPanel = ({ docs }: ReferenceDocPanelProps) => {
  if (docs.length === 0) return null;

  return (
    <div className='reference-doc-panel'>
      {docs.map(doc => (
        <article key={doc.file} className='reference-doc-panel-entry'>
          <h4 className='reference-doc-panel-title'>{doc.title}</h4>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{doc.markdown}</ReactMarkdown>
        </article>
      ))}
    </div>
  );
};
